<template>
    <entity-reader entity="monster" :id="id" api-name="monsters" :use-sharing="true" :allow-copy="true">
        <template v-slot:[`reader`]="{ doc }">
            <label-value name="Name" :value="doc.name" />
            <label-value name="Section" :value="doc.section" />
            <label-value name="Race" :value="doc.race" />
            <label-value name="Weakness" :value="doc.elementalWeakness" />
            <label-value name="Pattern Type" :value="getPattern(doc)" />
            <label-value name="Hits" :value="doc.hits" />
            <label-value name="Armour" :value="doc.armour" />
            <label-value name="Dismiss/Control" :value="doc.dismissControl" />
            <label-value name="Intelligence" :value="getIntelligence(doc)" />
            <label-value name="Immunities" :value="doc.immunities" />
            <label-value name="Strikes For" :value="doc.strikesFor" />
            <label-value name="Summoning" :value="doc.summoningAbility" />
            <label-value name="Ability" :value="getAbilities(doc)" />
            <label-value name="Notes" :value="doc.restrictionsAndNotes" />
            <label-value name="Guidelines" :value="doc.roleplayGuidelines" />
            <label-value name="Makeup Notes" :value="doc.makeupNotes" />
            <label-value name="Upstat" :value="doc.upstats" />
        </template>
    </entity-reader>
</template>
<script>
import EntityReader from '../../components/EntityRead'
import LabelValueRender from '../../components/LabelValueRender'
export default {
    name: 'MonsterReader',
    components: {
        'entity-reader': EntityReader,
        'label-value': LabelValueRender,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
            validator: value => {
                return !!value
            },
        },
    },
    methods: {
        getIntelligence(doc) {
            let intel = doc.intelligence
            if (doc.intelligenceEffect) {
                intel = `${intel} - ${doc.intelligenceEffect}`
            }
            return intel
        },
        getPattern(doc) {
            let pattern = doc.patternType
            if (doc.patternTypeEffect) {
                pattern = `${pattern} - ${doc.patternTypeEffect}`
            }
            return pattern
        },
        getAbilities(doc) {
            let abilities = doc.abilityOne
            if (doc.abilityTwo) {
                abilities = `${abilities}
                ${doc.abilityTwo}`
            }
            if (doc.abilityThree) {
                abilities = `${abilities}
                ${doc.abilityThree}`
            }
            return abilities
        },
    },
}
</script>
